import React from 'react'

const FIELDS = {
    cc_holder_name: {
        label: 'Name on Card',
        required: true,
        regex: null,
    },
    cc_number: {
        label: 'Card Number',
        required: true,
        regex: null,
    },
    payment_method: {
        label: '',
        required: true,
        regex: null,
    },
    cc_expiration_month: {
        label: 'Expiration Month',
        required: true,
        regex: null,
    },
    cc_expiration_year: {
        label: 'Expiration Year',
        required: true,
        regex: null,
    },
}

const REQUIRED_ICON_RENDER = <span className="tkc-text-red">*&nbsp;</span>

export {
    FIELDS,
    REQUIRED_ICON_RENDER,
}


// WEBPACK FOOTER //
// ./src/components/billing-form/constants/fieldsCreditCardChange.js